import React from 'react';
import c from '../w.js';

const IconArrowRight = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.7071 4.29297L21.4142 12.0001L13.7071 19.7072L12.2929 18.293L17.5858 13.0001H4V11.0001H17.5858L12.2929 5.70718L13.7071 4.29297Z"
      }
    )
  )
);

export { IconArrowRight };
